<header class="flex items-center justify-between">
  <div class="px-2">
    <p-button icon="bi bi-list" [rounded]="true" [text]="true" size="large" title="Toggle Menu" (onClick)="toggleOffcanvas()" [ngClass]="'lg:hidden'"></p-button>
  </div>
  <div class="text-center">
    <a routerLink="/" class="logo-link flex items-center justify-center site-font">
      <span>Tidy Ranking</span>
    </a>
  </div>
  <div></div>
</header>